export default "__VITE_ASSET__DTl75QtF__"